import { render, staticRenderFns } from "./IconSvgCRNDailySupplement.vue?vue&type=template&id=c43b050e&scoped=true&"
import script from "./IconSvgCRNDailySupplement.vue?vue&type=script&lang=js&"
export * from "./IconSvgCRNDailySupplement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c43b050e",
  null
  
)

export default component.exports